import React from "react";
import PhotoalbumJSON from "./PhotoalbumJSON.jsx";
import { formatDate } from "../../helpers/helpers.jsx";
import { useFetch, loading } from "../../helpers/hooks.jsx";
import json_navbar from "../UI/Navbar/Navbar.json";
import "./photogallery.css";

const Photogallery = ({ lang }) => {
  const [dirs, loadingDirs] = useFetch("https://sancta-cecilia.cz/photo_json.php");

  return (
    <div className="photogallery">
      <h1>{json_navbar.photos[lang]}</h1>
      {loadingDirs
        ? loading[lang]
        : dirs.map((dir, index) => (
            <div key={index} className="photogalleryGroup">
              <div className="photogalleryTitle">
                {dir.title[lang]}
                <p>{formatDate(lang, dir.path.substr(0, 10))}</p>
              </div>
              <PhotoalbumJSON lang={lang} dir={dir.path} />
            </div>
          ))}
    </div>
  );
};

export default Photogallery;



// WEBPACK FOOTER //
// ./src/components/Photogallery/Photogallery.jsx